import { KeySource, KeySourceLabels } from "../../enums/keySource";

/** Filter dropdown options for the Key Source column. */
export const allKeySourceOptions = Object.values(KeySource).map((value) => ({
  label: KeySourceLabels[value],
  value,
}));
